export enum AlertDefinition {
    StockbrokingAlerts = 1,
    PaymentOutAlerts = 2,
    ChargingAlerts = 3,
    TransferInAlerts = 4,
    OrderAlerts = 5,
    OtherAlerts = 6,
    CorporateActionInformation = 7,
    CorpActionDecisionAlert = 8,
    OrderComplete = 9,
    OrderRequested = 10,
    OrderExpiry = 11,
    OrderRejected = 12,
    OrderCancelled = 13,
    IneligibleISAStock = 14,
    NotificationDetailingTheResultOfAnApplicationToSubscribeToAnIPO = 15,
    TransferInStatusChange = 16,
    TransferInStockLineCompletion = 17,
    TransferInCompletionCrystallisedTransfer = 18,
    TransferInCompletionUncrystallisedTransfer = 19,
    TransferInCompletionImmediateCrystallisationTransfer = 20,
    TradeInstructed = 21,
    BulkAssetSwitchFailure = 22,
    RegularCrystallisationCancelled = 23,
    RegularCrystallisationInsufficientFunds = 24,
    RegularCrystallisationDelayed = 25,
    RegularCrystallisationNotification = 26,
    ClientApproachingLifetimeAllowance = 27,
    ReviewLifetimeAllowance = 28,
    DirectDebitCancellation = 29,
    PaymentInCompletedNotification = 30,
    OneOffPaymentInComplete = 31,
    IncomePaymentStrategyFailure = 32,
    LumpSumWithdrawal = 33,
    FirstRegularWithdrawal = 34,
    TaxFreeLumpSumWithdrawalComplete = 35,
    IncomeCancelledInsufficientCash = 36,
    InsufficientFundsToMeetChargesDue = 37,
    UnpaidAdviserCharges = 38,
    ClientMovedOutOfCoreProductRange = 39,
    GoneAway = 40,
    CashBalanceBelow1Percent = 41,
    CashBalanceBelow2Percent = 42,
    ModelToleranceRebalance = 43,
    ModelFrequencyToleranceRebalance = 44,
    InvestmentAlerts = 45,
    TransferCompletionAlert = 46,
    ExclusionOrSubstitutionReview = 47,
    SuitabilityReview = 48,
    TheSWIFTPaymentFailure = 49,
    ElectionDecisionRequired = 50,
    ClientApproachingIntendedRetirementDate3YearWakeUp = 51,
    ClientApproachingIRD = 52,
    ClientApproachingIRDReminder = 53,
    SingleCrystallisationExcessLta = 54,
    SingleCrystallisationInsufficientFunds = 55,
    SingleCrystallisationInsufficientCash = 56,
    SingleCrystallisationFullPcls = 57,
    FutureRegularCrystallisationToBeCancelled = 58,
    ElectionDecisionInsufficientCash = 59,
    SmartSwitchCancellation = 60,
    DimTransferOutCancellation = 61,
    BulkSmartSwitchCancellation = 62,
    RebalancedModelPortfolio = 63,
    NegativeCashBalance = 64,
    UnknowAlertDefinition = 65,
    DirectDebitForm = 66,
    MandatePPtoISA = 67,
    WithdrawalCancelledInsufficientCash = 68,
    FailedAdviserCharge = 69,
    KIDChanged = 70,
    MifidValueDrop = 71,
    RegularStatement = 72,
    RegularDimStatement = 73,
    DirectDebitFailure = 74,
    DealInstructed = 75,
    DealCancelled = 76,
    DealRequested = 77,
    DealComplete = 78,
    MoneyOutTransferComplete = 79,
    OutstandingAdviserCharge = 80,
    DealExpiry = 81,
    AutoDisinvestmentByInsufficientCash = 82,
    AssetStatusChange = 83,
    TransferInComplete = 84,
    ESignature = 85,
    TermsConditions = 86,
    ProxyRequestUpdateApproval = 87,
    ProxyRequestUpdateRejection = 88,
    JuniorPensionNationalInsurnaceNumber = 89,
    JuniorPensionApproachingMaturity = 90,
    JuniorPensionClientApproachingMaturity = 91,
    AnnualAllowanceExceeded = 95,
    PensionArrangementCannotSupportFutureIncome = 119,
    DrawdownPensionGADReview = 120,
    PensionClientApproachingRetirementAge = 121,
    PensionClientApproachingMinimumRetirementAge = 122,
    TermCashProductMaturity = 123,
    CashProductInterestRateChange = 124,
    ApproachingRetirementDate = 125
}
